import React, {FC} from "react"
import {Col, Row} from "react-bootstrap"
import {WellnessMedia, WellnessMediaType, MarketingProfile, UpdateMarketingProfileInput} from "@irati/types"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import LiveVideoPlayer from "./LiveVideoPlayer"
import MediaDetails from "./MediaDetails"
import Reminder from "./LiveVideoReminder"
import RelatedMediaList from "./RelatedMediaList"
import PremiumMediaVideoSection from "./PremiumMedia/PremiumMediaVideoSection"
import PremiumMediaAudioSection from "./PremiumMedia/PremiumMediaAudioSection"
import ExplorePremiumContent from "./ExplorePremiumContent"
import RentStaticMedia from "./RentStaticMedia"

interface Props extends InjectIntl {
  media: WellnessMedia
  marketingProfile: MarketingProfile
  handleClick: (marketingProfileInput: UpdateMarketingProfileInput) => void
  liveVideoInProgress: boolean
}

const MediaContent: FC<Props> = ({media, marketingProfile, liveVideoInProgress, handleClick}) => {
  const isPremiumContent = !!media.price
  const isMediaRented = !!media?.src?.length

  return (
    <Row>
      <Col md={8} sm={12}>
        {media.type === WellnessMediaType.SingleVideo && (
          <PremiumMediaVideoSection media={media} isPremiumContent={isPremiumContent} isMediaRented={isMediaRented} />
        )}
        {media.type === WellnessMediaType.SingleAudio && (
          <PremiumMediaAudioSection media={media} isPremiumContent={isPremiumContent} isMediaRented={isMediaRented} />
        )}
        {media.type === WellnessMediaType.LiveVideo && <LiveVideoPlayer media={media} liveVideoInProgress={liveVideoInProgress} />}
        <MediaDetails media={media} liveVideoInProgress={liveVideoInProgress} isPremiumContent={isPremiumContent} />
      </Col>
      <Col md={4} sm={12} xs={12}>
        {media.type !== WellnessMediaType.LiveVideo && isPremiumContent && !isMediaRented && <RentStaticMedia media={media} />}
        {media.type === WellnessMediaType.LiveVideo && !liveVideoInProgress && (
          <Reminder media={media} marketingProfile={marketingProfile} handleClick={handleClick} />
        )}
        {media.type !== WellnessMediaType.LiveVideo && isPremiumContent && <ExplorePremiumContent />}
        <RelatedMediaList media={media} marginTop={5} />
      </Col>
    </Row>
  )
}

export default injectIntl(MediaContent)
